import { createContext, type ComponentType } from "react";
import type { MentionKind } from "@cometchat-ai/core";

/**
 * Per-kind chip icon overrides, provided by `PromptMentionEditor` so each
 * `MentionChip` NodeView renders the SAME glyph the `#` picker uses for that
 * category (without prop-drilling through ProseMirror). Host apps supply the
 * map matching their icon set (e.g. the dashboard's iconsax glyphs). Missing
 * keys fall back to the chip's lucide defaults.
 */
export type KindIcon = ComponentType<{ className?: string; variant?: string }>;

export const KindIconsContext = createContext<Partial<Record<MentionKind, KindIcon>> | null>(null);
